'use client';
import SectionHeading from '@/components/layout/section-heading';
import { Check } from 'lucide-react';
export default function PublishingSupportSection({
    titleClassName,
    descriptionClassName,
    align,
    title,
    description,
    services,
}) {
    return (
        <section>
            <div className="container mb-8 md:mb-18">
                <SectionHeading
                    titleClassName={titleClassName}
                    descriptionClassName={descriptionClassName}
                    align={align}
                    title={title}
                    description={description}
                />
            </div>
            <div className="mx-auto max-w-7xl px-4">
                <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                    {services?.map((item) => (
                        <div
                            key={item}
                            className="flex items-center gap-3 rounded-xl bg-linear-to-b from-primary to-blue-600 p-4 shadow-sm"
                        >
                            <div className="flex items-center justify-center gap-2">
                                <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center bg-white/10 justify-center rounded-full text-white">
                                    <Check className="h-5 w-5 text-white mt-1 shrink-0" />
                                </span>

                                <p className="text-base font-medium text-white mb-0">{item}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
